import React from 'react';

export default function AIAssistantIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.46515C0 13.0637 2.01987 16.1933 4.98977 17.7965V1.13379C2.01987 2.73696 0 5.86655 0 9.46515Z"
        fill="#34A5AC"
      />
      <path
        d="M9.50309 0C8.35621 0 7.26068 0.213187 6.24219 0.588397V18.3512C7.26068 18.7264 8.35621 18.9396 9.50309 18.9396C14.7496 18.9396 19.0033 14.7014 19.0033 9.47404C19.0033 4.24669 14.7496 0 9.50309 0Z"
        fill="#34A5AC"
      />
    </svg>
  );
}
